<template>
  <v-container fluid>
    <v-dialog 
      v-model = "createVersionDialog" 
      width="500">
      <v-card>
        <v-card-title
          class="headline"
          primary-title>
          {{ selected && selected.length && selected.length === 1 ? 'Rename Version' : 'Duplicate Version Name' }}
        </v-card-title>
        <v-card-text>
          <add-version
            ref = "addVersion"
            :put = "selected && selected.length && selected.length === 1 ? selected[0] : null"
            @loading = "addButtonLoader = $event"
            @success = "createVersionDialog = false">
              <label slot = "before-name">Version Name</label>
              <label slot = "before-culture">Version Culture</label>
              <label slot = "before-disc">Version Discreption</label>
          </add-version>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createVersionDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="addNewVersion">
            {{ selected && selected.length && selected.length === 1 ? 'Rename' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteVersionDialog" 
      width="400">
      <v-card v-if = "selected && selected.length">
        <v-card-title
          class="headline"
          primary-title>
          Delete {{ selected.map(version => version.name).join(', ') }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this Version?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :loading = "addButtonLoader"
            color="error"
            outline
            @click="deleteVersions">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteVersionDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout 
      row 
      wrap>
      <h1>My Versions</h1>
      <v-spacer />
      <app-actions />
    </v-layout>
    <v-flex xs12>
      <v-card class = "card-curvey">
        <v-layout 
          row 
          wrap>
          <v-flex xs4>
            <v-text-field
              v-model = "queries.q"
              placeholder = "Search By Name.."
              versionend-icon = "search"
              outline />
          </v-flex>
          <v-spacer />
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            :loading = "!!(addButtonLoader && selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(false)">
            <v-icon>edit</v-icon>
            Rename
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "deleteVersionDialog = true">
            <span 
              class="botter-trash-icon" 
              style="padding-right: 6px"/>
            Delete
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "activateVersion">
            Activate
          </v-btn>
          <v-btn
            :loading = "!!(addButtonLoader)"
            :disabled = "!selected || !selected.length || selected.length !== 1"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "cloneVersion">
            <v-icon>file_copy</v-icon>
            Duplicate
          </v-btn>

        </v-layout>
        <v-flex xs12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="queriedVersions"
            item-key="name"
            no-data-text = "No Versions Available"
            select-all
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr v-if = "props.item.name">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td>
                  <span
                    class = "primary--text pointer-cursor">
                    {{ props.item.name }}
                  </span>
                </td>
                <td class="text-center"> <v-icon :color = "props.item.status === 'ACTIVE' ? 'success' : 'red'">circle</v-icon> </td>
                <td class="text-center">{{ props.item.published_at ? $moment(props.item.published_at).format('h:m A D/MMM/YYYY') : '' }}</td>
                <td class="text-center">{{ $moment(props.item.created_at).format('h:m A D/MMM/YYYY') }}</td>
                <td class="text-center">{{ $moment(props.item.updated_at).format('h:m A D/MMM/YYYY') }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
import AddVersion from '../../../components/nlp/versions/AddVersion.vue'
import AppActions from '../common/AppActions'
export default {
  name: 'Nlp',
  components: {
    AddVersion,
    AppActions
  },
  data() {
    return {
      queries: {
        q: ''
      },
      createVersionDialog: false,
      deleteVersionDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        {
          text: 'Version Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Status',
          value: 'status'
        },
        { text: 'Publish Date', value: 'published_at', align: 'center' },
        { text: 'Created At', value: 'created_at', align: 'center' },
        { text: 'Last Modified', value: 'updated_at', align: 'center' },
        // { text: '', value: 'actions' }
      ]
    }
  },
  computed: {
    queriedVersions() {
      return this.$store.getters['nlp/versions/query'](this.queries.q)
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if(val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]]
        }
      }
    }
  },
  mounted() {
    // get versions
    this.getVersions()
  },
  methods: {
    // cloneVersion() {
    //   this.addButtonLoader = true
    //   const payload = this.$_.pick(this.selected[0], ['name'])
    //   this.$store.dispatch('nlp/versions/add', payload).then(()=>{
    //     this.addButtonLoader = false
    //   }).catch(()=> {
    //     this.addButtonLoader = false
    //   })
    // },
    getVersions(callback = null) {
      this.$store.dispatch('nlp/versions/get', null)
      .then(()=>{
        if(callback)
          callback()
      })
      .catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    openAddDialog(reset = true) {
      if(reset)
        this.selected = []
      this.createVersionDialog = true
    },
    cloneVersion(){
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('nlp/versions/clone', this.selected[0].id)
        .then(() => {
          this.refreshVersions(this.queriedVersions.length)
          this.$store.dispatch('setSnackbar', {
            text: `Cloned Successfully`,
            color: 'success'
          })
          this.selected = []
          this.$store.dispatch('setLoader', false)
        })
        .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    },
    refreshVersions(count = this.queriedVersions.length) {
      this.getVersions(()=>{
        if (this.queriedVersions.length <= count) {
          this.$store.dispatch('setLoader', 'Cloning...')
          setTimeout(()=>{
            this.refreshVersions(count)
          }, 2000)
        }
      })
    },
    activateVersion(){
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('nlp/versions/activate', this.selected[0].id)
        .then(() => {
          this.$store.dispatch('setSnackbar', {
            text: `Activated Successfully`,
            color: 'success'
          })
          this.getVersions()
          this.selected = []
          this.$store.dispatch('setLoader', false)
        })
        .catch((err) => {
          this.$store.dispatch('setErrorMessage', (err && err.response && err.response.data && err.response.data.error) ? err.response.data.error : true)
          this.$store.dispatch('setLoader', false)
        })
    },
    addNewVersion() {
      if (this.$refs.addVersion) this.$refs.addVersion.submit()
    },
    selectVersion(version) {
      this.$store.dispatch('nlp/versions/select', version)
      this.$router.push(`/nlp/version/${version.id}/intents`)
    },
    deleteVersions() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('nlp/versions/delete/single', this.selected[0].id)
        .then(() => {
          this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
          })
          this.selected = []
          this.$store.dispatch('setLoader', false)
        })
        .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    }
  }
}
</script>

<style lang="scss" src="../../../assets/sass/commponents/nlp.scss">
</style>
